import Vue from "vue"
import Vuex from "vuex"
import { HTTP_CONFIG } from '@/config/config.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: {
      username: "",
      timestamp: null,
      token: ""
    },
    isAuthenticated: false,
    permissions: {
      home_page: false,
      environmental: false,
      aicontrol: false,
      hostel: false,
      patrol: false,
      user: false,
      laundry: false,
      engery: false
    },
    loading: false,
    error: null
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = {
        username: userInfo.username || "",
        timestamp: userInfo.timestamp || null,
        token: userInfo.token || ""
      }
    },
    CLEAR_USER_INFO(state) {
      state.userInfo = {
        username: "",
        timestamp: null,
        token: ""
      }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_AUTHENTICATED(state, authenticated) {
      state.isAuthenticated = authenticated
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = { ...permissions }
    },
    CLEAR_AUTH(state) {
      state.isAuthenticated = false
      state.permissions = {
        home_page: false,
        environmental: false,
        aicontrol: false,
        hostel: false,
        patrol: false,
        user: false,
        laundry: false,
        engery: false
      }
      state.error = null
    }
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit("SET_USER_INFO", userInfo)
    },
    clearUserInfo({ commit }) {
      commit("CLEAR_USER_INFO")
    },
    // 从URL参数获取token信息
    extractTokenFromUrl({ commit }) {
      const urlParams = new URLSearchParams(window.location.search)
      // 支持大小写两种参数名
      const rawToken = urlParams.get("Token") || urlParams.get("token")
      const rawUsername = urlParams.get("Username") || urlParams.get("username")
      const rawTimestamp = urlParams.get("Timestamp") || urlParams.get("timestamp")

      // 控制台打印参数值
      console.log("Username:", rawUsername)
      console.log("Timestamp:", rawTimestamp)
      console.log("Token:", rawToken)
      const headers = {
            'USERNAME': rawUsername,
            'TOKEN': rawToken,
            'TIMESTAMP': rawTimestamp
          };
          
      // 单独存储洗衣模块的 token
      localStorage.setItem('laundry_headers', JSON.stringify(headers));
      console.log('洗衣模块 headers:', headers);
      
      if (rawToken && rawUsername && rawTimestamp) {
        commit("SET_USER_INFO", { token: rawToken, username: rawUsername, timestamp: rawTimestamp })
        return { token: rawToken, username: rawUsername, timestamp: rawTimestamp }
      }
      return null
    },
    // 验证用户权限
    async verifyPermissions({ commit, state }) {
      if (!state.userInfo.token || !state.userInfo.username || !state.userInfo.timestamp) {
        commit("SET_ERROR", "缺少必要的认证参数")
        return false
      }
      
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      
      try {
        
        const username = encodeURIComponent(state.userInfo.username)
        console.log("发送验证码")
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/setperms/${username}/`, {
          method: "GET",

          headers: {
            USERNAME: state.userInfo.username,
            TIMESTAMP: state.userInfo.timestamp,
            TOKEN: state.userInfo.token
          }
        })
        
        if (!response.ok) {
          const errorText = await response.text().catch(() => "")
          commit("SET_ERROR", `服务错误(${response.status}) ${errorText}`.trim())
          return false
        }
        
        const data = await response.json()
        
        if (data.code === 200 && data.data) {
          // data.data 直接就是用户权限对象
          const userPermissions = data.data
          console.log("用户权限", userPermissions)
          
          // 动态提取所有值为 true 的权限字段
          const permissions = {}
          Object.keys(userPermissions).forEach(key => {
            if (typeof userPermissions[key] === 'boolean' && userPermissions[key] === true) {
              permissions[key] = true
            } else {
              permissions[key] = false
            }
          })
          
          // 确保所有预定义的权限字段都存在
          const finalPermissions = {
            home_page: permissions.home_page || false,
            environmental: permissions.environmental || false,
            aicontrol: permissions.aicontrol || false,
            hostel: permissions.hostel || false,
            patrol: permissions.patrol || false,
            user: permissions.user || false,
            laundry: permissions.laundry || true,// 新增洗衣服权限
            engery: permissions.engery || true
          }
          
          commit("SET_PERMISSIONS", finalPermissions)
          commit("SET_AUTHENTICATED", true)
          return true
        } else {
          commit("SET_ERROR", data.message || "权限验证失败")
          return false
        }
      } catch (error) {
        console.error("权限验证失败:", error)
        commit("SET_ERROR", "网络错误，无法验证权限")
        return false
      } finally {
        commit("SET_LOADING", false)
      }
    },
    // 初始化认证
    async initAuth({ dispatch, commit }) {
      // 先清除之前的认证状态
      commit("CLEAR_AUTH")
      
      // 从URL提取token信息
      const tokenInfo = await dispatch("extractTokenFromUrl")
      
      if (!tokenInfo) {
        commit("SET_ERROR", "URL中缺少认证参数")
        return false
      }
      
      // 验证权限
      return await dispatch("verifyPermissions")
    }
  },
  getters: {
    getUserInfo: state => state.userInfo,
    getUsername: state => state.userInfo.username,
    getTimestamp: state => state.userInfo.timestamp,
    getToken: state => state.userInfo.token,
    isLoggedIn: state => !!(state.userInfo.username && state.userInfo.token),
    isAuthenticated: state => state.isAuthenticated,
    // hasPermission: (state) => (permission) => {
    //   return state.permissions[permission] || false
    // },
    hasPermission: (state) => (permission) => {
      return state.permissions[permission] || true
    },
    canAccessModule: (state) => (module) => {
      const modulePermissions = {
        // AI 全域智控相关子路由
        traffic: "aicontrol",
        substation: "aicontrol",
        // 环境监测相关子路由
        monitor: "environmental",
        meter: "environmental",
        device: "environmental",
        analysis: "environmental",
        history: "environmental",
        // 智慧宿舍相关子路由
        VisualDormitory: "hostel",
        dormitory: "hostel",
        // 权限管理
        permission: "user",
        // 其他按照一级模块名兜底（若直接传模块名）
        environmental: "environmental",
        aicontrol: "aicontrol",
        hostel: "hostel",
        patrol: "patrol",
        // 洗衣服相关子路由
        'laundry-stats': 'laundry',
        'laundry-order': 'laundry', 
        'laundry-device': 'laundry',
        'laundry-notification': 'laundry',
        'laundry-complaint': 'laundry',
        'laundry-user': 'laundry',
        'laundry-permission': 'laundry',
        'laundry-report': 'laundry',
        // 能源监控相关子路由
        'engery-monitor': "engery",
        'engery-sample': "engery",
        'engery-manage': "engery",
        'engery-history': "engery",
        'engery-repair': "engery",
        'engery-statistics': "engery",
        'engery': "engery",
      }
      const requiredPermission = modulePermissions[module]
      return requiredPermission ? state.permissions[requiredPermission] : false
    }
  }
})

export default store
